import { CssBaseline } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as React from "react";
import { localStorageStore, StoreContext } from "react-admin";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider, ScrollRestoration } from "react-router-dom";
import { App } from "./App";
import { RootErrorBoundary } from "./error";
import { AccountProvider, WebsiteProvider } from "./hooks";

declare const isDevelopment: boolean;
export const day = 1000 * 60 * 60 * 24;
export const fiveMin = 1000 * 60 * 5;

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            staleTime: fiveMin,
        },
    },
});

const Root = () => {
    return <>
        <CssBaseline />
        <ScrollRestoration />
        <QueryClientProvider client={queryClient}>
            <StoreContext.Provider value={localStorageStore()}>
                <WebsiteProvider>
                    <AccountProvider>
                        <App queryClient={queryClient} />
                    </AccountProvider>
                </WebsiteProvider>
            </StoreContext.Provider>
        </QueryClientProvider>
    </>
};

let router = createBrowserRouter([
    {
        path: "*",
        Component: Root,
        ErrorBoundary: RootErrorBoundary
        // loader: loadRootData,
    },
]);

const root = createRoot(document.getElementById("root")!);
root.render(<React.StrictMode>
               <RouterProvider router={router} />
            </React.StrictMode>);
